<template>
  <div>
    <!--    <div class="form-group">-->
    <!--      <label for="">Основная страна закупки</label>-->
    <!--      <select class="form-control" v-model="drug.income_country_id">-->
    <!--        <option v-for="country in $AllCountries" :value="country.id">{{ country.name }}</option>-->
    <!--      </select>-->
    <!--    </div>-->
    <div class="mt-1">
      <select v-model="newCountry" @change="addNewCountry" class="form-control">
        <option value="0">Выберите дополнительную страну</option>
        <option :value="country.id" v-for="country in $AllCountries">{{ country.name }}</option>
      </select>
      <div>
        <div class="input-group" v-for="country in details"
             v-if="!country || !country.to_delete">
          <input
            v-model="country.name"
            disabled
            class="form-control"
          />
          <div class="input-group-append">
            <button type="button" @click="removeCountry(country)" class="btn btn-outline-danger">
              <i class="icon-fa icon-fa-trash"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['drug', 'details'],
  data() {
    return {
      newCountry: 0,
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  methods: {
    removeCountry(record) {
      const index = this.details.findIndex((c) => c.value === record.value);
      if (index !== -1) {
        this.details[index].to_delete = true;
        // this.details = {...this.details};
      }
    },
    addNewCountry(e) {
      if (this.newCountry) {
        if (!this.details) this.details = [];
        const selected = this.details.find((d) => +d.value === +this.newCountry);
        if (selected || +this.newCountry === this.drug.income_country_id) {
          toastr['warning']('Страна уже используется для этого препарата');
          this.newCountry = 0;
          return;
        }
        const country = this.$AllCountries.find((c) => c.id === +this.newCountry);
        this.details.push({
          alias: "country",
          group_alias: 'extra',
          type: "int",
          to_delete: false,
          value: country.id,
          name: country.name
        });
      }
      this.newCountry = 0;
    },
  }
}

</script>
